<template>
  <div>
    <v-dialog v-model="dialog" max-width="900">
      <template v-slot:activator="{ on, attrs }">
        <div class="d-flex">
          <v-btn class="mx-2 transparent" fab small v-bind="attrs" v-on="on">
            <v-icon> mdi-eye-outline </v-icon>
          </v-btn>
        </div>
      </template>
      <v-sheet
        class="gradient-sheet align-center justify-center text-center"
        height="100%"
      >
        <v-row class="fill-height">
          <v-col cols="10" md="6" class="d-flex">
            <div>
              <img
                v-if="user.avatar"
                :src="user.avatar"
                :alt="user.name"
                width="400px"
                height="400px"
              />
              <v-icon
                v-else
                color="white"
                size="400px"
                class="mdi mdi-account"
              ></v-icon>
              <div class="info-card-person">
                <p class="text-h3">
                  {{ user.name }},
                  {{ user.year }}
                  Anos - {{ user?.Formacao || 'Não informado' }}
                </p>
              </div>
            </div>
          </v-col>

          <v-col cols="12" md="6" class="text-center">
            <h3 class="text-h3">Desempenho geral</h3>
            <v-row cols="4">
              <v-col cols="12" class="">
                <div class="d-flex justify-end align-center">
                  <div class="text-h4">Avaliação geral:</div>
                  <v-rating
                    v-model="user.avaliation.geral"
                    readonly
                    background-color="orange lighten-3"
                    color="orange"
                    half-increments
                    hover
                    length="5"
                    size="25"
                  >
                  </v-rating>
                  <div class="align-self-start">
                    <sub>{{ user.avaliation.geral }}</sub>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" class="">
                <div class="d-flex justify-end align-center">
                  <div class="text-h4">Efetividade / Relevância no campo:</div>
                  <v-rating
                    v-model="user.avaliation.efetividade"
                    readonly
                    background-color="orange lighten-3"
                    color="orange"
                    half-increments
                    hover
                    length="5"
                    size="25"
                  >
                  </v-rating>
                  <div class="align-self-start">
                    <sub>{{ user.avaliation.efetividade }}</sub>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" class="">
                <div class="d-flex justify-end align-center">
                  <div class="text-h4">Engajamento nas redes sociais:</div>
                  <v-rating
                    v-model="user.avaliation.engajamento"
                    readonly
                    background-color="orange lighten-3"
                    color="orange"
                    half-increments
                    hover
                    length="5"
                    size="25"
                  >
                  </v-rating>
                  <div class="align-self-start">
                    <sub>{{ user.avaliation.engajamento }}</sub>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" class="">
                <div class="d-flex justify-end align-center">
                  <div class="text-h4">Influência no grupo:</div>
                  <v-rating
                    v-model="user.avaliation.influencia"
                    readonly
                    background-color="orange lighten-3"
                    color="orange"
                    half-increments
                    hover
                    length="5"
                    size="25"
                  >
                  </v-rating>
                  <div class="align-self-start">
                    <sub>{{ user.avaliation.influencia }}</sub>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" class="">
                <div class="d-flex justify-end align-center">
                  <div class="text-h4">Pontualidade nas entregas:</div>
                  <v-rating
                    v-model="user.avaliation.pontualidade"
                    readonly
                    background-color="orange lighten-3"
                    color="orange"
                    half-increments
                    hover
                    length="5"
                    size="25"
                  >
                  </v-rating>
                  <div class="align-self-start">
                    <sub>{{ user.avaliation.pontualidade }}</sub>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" class="">
                <div class="d-flex justify-end align-center">
                  <div class="text-h4">Execução agenda de visitas:</div>
                  <v-rating
                    v-model="user.avaliation.execucao"
                    readonly
                    background-color="orange lighten-3"
                    color="orange"
                    half-increments
                    hover
                    length="5"
                    size="25"
                  >
                  </v-rating>
                  <div class="align-self-start">
                    <sub>{{ user.avaliation.execucao }}</sub>
                  </div>
                </div>
              </v-col>

              <v-col cols="12">
                <div class="supervision">
                  <p class="text-h3">
                    Número de supervisões recebidas:
                    <strong>
                      {{ user.avaliations.length || 0 }}
                    </strong>
                  </p>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-sheet>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'AvaliationGeneral',

  props: {
    user: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      dialog: false,
    }
  },
}
</script>

<style scoped>
.gradient-sheet {
  background: linear-gradient(to bottom right, #0d133d, #243189);
  padding: 20px;
  border-radius: 8px;
}
.info-card-person {
  border: 5px solid #32bd50;
  border-radius: 1rem;
  padding: 0.4rem;
  max-width: 300px;
  /* position: absolute; */
  bottom: 15px;
  margin-left: 50px;
}

.supervision {
  border: 5px solid #32bd50;
  border-radius: 1rem;
  padding: 0.4rem;
}
</style>
